import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import classnames from 'clsx';

import Global from '../../../../store/global-selectors';

import { DisplayGridRecordPropType } from '../../../prop-types/display-grid-record';
import { DisplayGridGroupRecordPropType } from '../../../prop-types/display-grid-group-record';
import { noop } from '../../../default-props/noop';
import { generateDataTestidAttribute } from '../../../services/testid-service';

import styles from './style.module.css';

export const DisplayGridCell = memo(
  React.forwardRef(
    (
      {
        children = null,
        className,
        column,
        onClick = noop,
        onDoubleClick = noop,
        onMouseEnter = noop,
        onMouseLeave = noop,
        style,
        data,
        allData,
        dataRowId,
        isFirstRow = true,
        isFirstOfType = true,
        isExpanded = false,
        isDisabled = false,
      },
      ref,
    ) => {
      const activeGroupBys = useSelector(Global.selectOrdersGridActiveGroupByEnums);
      const isActiveGroupByColumn = activeGroupBys.map((gb) => gb.id).includes(column.id);
      const classNames = classnames(className, {
        [styles['active-groupby-column']]: isActiveGroupByColumn,
      });
      return (
        <div // oxlint-disable-line jsx-a11y/no-noninteractive-element-interactions
          ref={ref}
          className={classNames}
          data-column={column.id}
          data-row-id={dataRowId}
          onClick={onClick}
          onDoubleClick={onDoubleClick}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          role='cell'
          style={style}
          {...generateDataTestidAttribute(column.id)}
        >
          {column &&
            column.render &&
            column.render(data, {
              allData,
              isFirstRow,
              isFirstOfType,
              isExpanded,
              isDisabled,
            })}
          {children}
        </div>
      );
    },
  ),
);

DisplayGridCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  column: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.object,
    render: PropTypes.func,
  }).isRequired,
  data: PropTypes.oneOfType([DisplayGridRecordPropType, DisplayGridGroupRecordPropType]),
  allData: PropTypes.oneOfType([DisplayGridRecordPropType, DisplayGridGroupRecordPropType]),
  dataRowId: PropTypes.string,
  onClick: PropTypes.func,
  onDoubleClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  style: PropTypes.object,
  isFirstOfType: PropTypes.bool,
  isFirstRow: PropTypes.bool,
  isExpanded: PropTypes.bool,
  isDisabled: PropTypes.bool,
};
